export enum CreateRemittanceGroupResponseEnum {
  SUCCESS = 200,
  FAIL = 400,
  ALREADY_EXIST
}
